var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container"},[_c('div',{staticClass:"content-box"},[_c('el-button',{staticStyle:{"background":"#f06400","border-color":"#f06400"},attrs:{"type":"primary"},on:{"click":_vm.getRestore}},[_vm._v("恢复出厂")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }